var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-select',{attrs:{"id":_vm.id,"value":_vm.value,"options":_vm.tags,"placeholder":"Select or add a tag","label":"name","multiple":true,"taggable":true},on:{"change":function($event){return _vm.$emit('change', $event)},"tag":_vm.addTag}})}
var staticRenderFns = []

export { render, staticRenderFns }